import { buildCourseProgressRoute, buildCourseRoute } from '~/routes';

export const getCourseUrl = (slug, isStarted = false) =>
  isStarted ? buildCourseProgressRoute(slug) : buildCourseRoute(slug);
